export const CITY_KEY_RE = /^[a-z0-9-]+$/;

/** Generate a target_cities.city_key slug from an English display name. */
export function slugifyCityKey(name: string): string {
  const normalized = name
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ä/g, "a")
    .replace(/ö/g, "o")
    .replace(/ü/g, "u")
    .replace(/ß/g, "ss");

  return normalized
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function isValidCityKey(cityKey: string): boolean {
  return CITY_KEY_RE.test(cityKey);
}
